import { useNavigate } from "react-router-dom";
import Fb from "../../src/assets/svg/fb.svg";
import Instagram from "../../src/assets/svg/instagram.svg";
import YouTube from "../../src/assets/svg/youtube.svg";

export function Footer() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center w-full gap-6 px-6 py-10 bg-white border-t border-extra-light">
      <div className="flex flex-col w-full gap-6 px-6 pb-10 border-b border-extra-light">
        {/* Social media links */}
        <div className="flex items-center justify-center gap-2">
          <a
            href="https://www.facebook.com/CitroenHrvatska/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Fb} alt="Facebook"></img>
          </a>
          <a
            href="https://www.instagram.com/citroenhrvatska/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Instagram} alt="Instagram"></img>
          </a>
          <a
            href="https://www.youtube.com/user/citroencroatia"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={YouTube} alt="YouTube"></img>
          </a>
        </div>

        {/* Legal links */}
        <div className="flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <div className="flex justify-center gap-3">
            <a
              href="https://www.citroen.hr/korisne-informacije/izjava-o-privatnosti.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-right text-black text-nowrap opacity-70"
            >
              Izjava o privatnosti
            </a>
            <div className="border border-black h-[13px] border-opacity-10"></div>
            <a
              href="https://www.citroen.hr/korisne-informacije/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-left text-black text-nowrap opacity-70"
            >
              Pravna obavijest
            </a>
          </div>
          <div className="hidden border border-black h-[13px] sm:flex border-opacity-10"></div>
          <div className="flex justify-center gap-3">
            <a
              href="https://www.citroen.hr/korisne-informacije/cookies.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-right text-black text-nowrap opacity-70"
            >
              Kolačići
            </a>
            <div className="border h-[13px] border-black border-opacity-10"></div>
            <a
              href="https://www.citroen.hr/sitemap.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-xs font-medium text-left text-black text-nowrap opacity-70"
            >
              Mapa stranice
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="flex justify-center gap-4 text-[11px]">
        © Citroën {new Date().getFullYear()}
      </div>
    </div>
  );
}

export default Footer;
